import {
  dreamControllerFindOne,
  getDreamControllerFindOneQueryKey,
} from '@/api/dreams/dreams'
import { OwnerDream } from '@/features/dream/views/owner-dream'
import { client } from '@/features/query/client'
import CoinAnimation from '@/ui/loader'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dreams/my/$id')({
  component: RouteComponent,
  loader: async ({ params: { id } }) => {
    return Promise.allSettled([
      client.prefetchQuery({
        queryKey: getDreamControllerFindOneQueryKey(id),
        queryFn: () => dreamControllerFindOne(id),
      }),
    ])
  },
  pendingComponent: CoinAnimation,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <OwnerDream id={id} />
}
